import { useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import Navbar from "../../components/Navbar2";
import FooterComponent from "../../components/Footer";
import ContactSalesModal from "./ai/misc/ContactSalesModal";
import { useSearchParams } from "react-router-dom";

function MainPricing() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("Id");
  const [billingCycle, setBillingCycle] = useState<
    "Monthly" | "Quarterly" | "Yearly"
  >("Yearly");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [showContactModal, setShowContactModal] = useState(false);

  const plans = [
    {
      name: "AI Recruiter",
      description: "AI-Powered Interview Platform",
      price:
        billingCycle === "Yearly"
          ? 650000
          : billingCycle === "Quarterly"
            ? 685000
            : 720000,
      popular: false,
      features: [
        "AI-driven candidate interviews",
        "Advanced analytics & reporting",
        "Automated grading & filtering",
        "Up to 200 AI-powered interviews/month",
        "100GB video storage (12 months)",
      ],
      link: `/price?Id=${id}&frequency=${billingCycle.toUpperCase()}`,
    },
    {
      name: "25th Direct",
      description: "Talent Intelligence Platform (TIP)",
      price:
        billingCycle === "Yearly"
          ? 689000
          : billingCycle === "Quarterly"
            ? 725000
            : 765000,
      popular: true,
      features: [
        "CV Capacity: Unlimited Database Size",
        "User Seats: Unlimited Users",
        "Job Matching: AI + Skill Gap Analysis",
        "Search Capabilities: Advanced + Semantic Search",
        "Export/Reporting: Full Analytics Suite & BI Tools",
      ],
      link: `/pricing/direct?Id=${id}&frequency=${billingCycle.toUpperCase()}`,
    },
    // {
    //   name: "25th Console",
    //   description: "Smart CV Intelligence & Shortlisting",
    //   price: billingCycle === "Yearly" ? 420000 : billingCycle === "Quarterly" ? 440000 : 465000,
    //   popular: false,
    //   features: [
    //     "Jobs Master Record",
    //     "KPI Task Analytics",
    //     "KPI Ticketing Analytics",
    //     "Candidates Master Record",
    //     "Job Match System",
    //   ],
    //   link: `/pricing/console?Id=${id}&frequency=${billingCycle.toUpperCase()}`,
    // },
  ];

  const faqs = [
    {
      question: "What's included in each plan?",
      answer:
        "Each plan includes access to our AI-powered recruitment tools, with varying levels of features and integrations. All plans include customer support, regular updates, and secure data handling. Higher tiers offer more advanced automation and integration capabilities.",
    },
    {
      question: "Can I customize my plan?",
      answer:
        "Yes! We offer flexible customization options to match your specific hiring needs. Contact our sales team to discuss custom integrations, additional users, or enterprise-level features tailored to your organization.",
    },
    {
      question: "What payment methods do you accept?",
      answer:
        "We accept bank transfers, credit cards, and can accommodate invoice-based billing for enterprise customers. Annual subscriptions can also be paid in installments upon request.",
    },
    {
      question: "Who is this platform for?",
      answer:
        "Our platform is built for startups, SMEs, enterprises, and recruitment agencies looking to hire faster, smarter, and more efficiently—locally or globally.",
    },
    {
      question: "How does the AI improve my hiring process?",
      answer:
        "Our AI helps automate candidate sourcing, shortlisting, and matching by analyzing skills, experience, and role requirements. This reduces time-to-hire, minimizes bias, and improves candidate quality.",
    },
    {
      question: "Can I integrate this with my existing tools?",
      answer:
        "Yes. We support integrations with popular ATS platforms, HR tools, and third-party applications. Advanced integrations are available on higher-tier or custom plans.",
    },
    {
      question: "Is my data secure?",
      answer:
        "Absolutely. We follow strict data security and privacy standards, including encrypted data storage and secure access controls, to protect both company and candidate information.",
    },
    {
      question: "Can I customize my recruitment plan?",
      answer:
        "Yes, you can customize your recruitment plan based on your hiring needs. We offer flexible and enterprise-level plans that allow custom workflows, integrations, reporting, and automation features tailored to your organization’s goals.",
    },
    {
      question: "How does AI improve the hiring process?",
      answer:
        "AI improves the hiring process by automatically sourcing candidates, matching skills to job requirements, and ranking applicants based on relevance. This reduces manual screening, minimizes bias, and enables faster, data-driven hiring decisions.",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white font-abel">
      <Navbar title="Login" link="/login" />
      {/* <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <span className="text-2xl font-medium text-blue-600">25th</span>
              </div>
            </div>

            <div className="hidden md:flex items-center space-x-8">
              <a
                href="#features"
                className="text-gray-700 hover:text-blue-600 transition"
              >
                Features
              </a>
              <a
                href="#pricing"
                className="text-gray-700 hover:text-blue-600 transition"
              >
                Pricing
              </a>
              <a
                href="#faq"
                className="text-gray-700 hover:text-blue-600 transition"
              >
                FAQ
              </a>
              <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition">
                Get Started
              </button>
            </div>

            <div className="md:hidden">
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="text-gray-700"
              >
                {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-4 pt-2 pb-4 space-y-3">
              <a
                href="#features"
                className="block text-gray-700 hover:text-blue-600 py-2"
              >
                Features
              </a>
              <a
                href="#pricing"
                className="block text-gray-700 hover:text-blue-600 py-2"
              >
                Pricing
              </a>
              <a
                href="#faq"
                className="block text-gray-700 hover:text-blue-600 py-2"
              >
                FAQ
              </a>
              <button className="w-full bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition">
                Get Started
              </button>
            </div>
          </div>
        )}
      </nav> */}

      {/* Hero Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 text-center">
        <h1 className="text-5xl md:text-[50px] font-medium text-gray-900 mb-6 leading-tight">
          The Perfect AI-Powered
          <br />
          <span className="text-blue-600">Recruiter Plan</span> for Your
          Business
        </h1>
        {/* <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto leading-relaxed">
          Flexible solutions for interviews, analytics, CV intelligence, job
          board integration, and more all scale with you
        </p> */}
        {/* <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a href="#pricing">
            <button className="mx-auto border border-[#0B60D6] bg-gradient-to-r from-[#1976D2]/0 to-[#0B60D6]/0 text-[#0B60D6] hover:shadow-lg transform hover:scale-105 py-2 px-5 rounded-lg transition-all flex items-center justify-center mb-4">
              View Plans
            </button>
          </a>
        </div> */}
      </section>

      {/* Features Section */}
      {/* <section id="features" className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-4xl font-medium text-gray-900 mb-4">
              Execution at Scale
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Built on 10 years of enterprise and SME delivery, we design
              automation that performs under real operational pressure. This is
              why we have delivered AI Recruiter, 25th Direct and 25th Console
              engineered for control, reliability and measurable impact.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-6 rounded-xl hover:shadow-lg transition">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Zap className="text-blue-600" size={32} />
              </div>
              <h3 className="text-xl text-gray-900 mb-3">
                AI-Powered Automation
              </h3>
              <p className="text-gray-600">
                Automate candidate screening, interviews, and shortlisting with
                advanced AI technology
              </p>
            </div>

            <div className="text-center p-6 rounded-xl hover:shadow-lg transition">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="text-blue-600" size={32} />
              </div>
              <h3 className="text-xl text-gray-900 mb-3">
                Seamless Integration
              </h3>
              <p className="text-gray-600">
                Connect with Jobberman, LinkedIn, and major job boards across
                multiple regions
              </p>
            </div>

            <div className="text-center p-6 rounded-xl hover:shadow-lg transition">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <TrendingUp className="text-blue-600" size={32} />
              </div>
              <h3 className="text-xl text-gray-900 mb-3">
                Advanced Analytics
              </h3>
              <p className="text-gray-600">
                Get deep insights with comprehensive reporting and data
                visualization tools
              </p>
            </div>

            <div className="text-center p-6 rounded-xl hover:shadow-lg transition">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="text-blue-600" size={32} />
              </div>
              <h3 className="text-xl text-gray-900 mb-3">
                Enterprise Security
              </h3>
              <p className="text-gray-600">
                Bank-level security with role-based access and complete data
                protection
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Pricing Section */}
      <section
        id="pricing"
        className="py-10 bg-gradient-to-b from-blue-50 to-white"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {plans.map((plan) => (
              <div
                key={plan.name}
                className={`bg-white rounded-2xl shadow-lg p-8 relative ${
                  plan.popular
                    ? "border-2 border-blue-600 transform scale-105"
                    : ""
                }`}
              >
                {plan.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-blue-600 text-white px-4 py-1 rounded-full text-sm font-medium">
                      Most Popular
                    </span>
                  </div>
                )}

                <div className="text-center mb-6">
                  <h3 className="text-2xl font-medium text-gray-900 mb-2">
                    {plan.name}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">
                    {plan.description}
                  </p>
                  <button
                    onClick={() => (window.location.href = plan.link)}
                    className="w-full bg-primary text-white border border-primary py-3 rounded-lg hover:bg-primary hover:text-white transition font-medium"
                  >
                    View Plan
                  </button>
                </div>

                <ul className="space-y-3">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <Check
                        className="text-green-600 flex-shrink-0 mt-0.5"
                        size={20}
                      />
                      <span className="text-gray-700 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* <div className="text-center">
            <button className="bg-blue-800 text-white px-8 py-4 rounded-lg hover:bg-blue-900 transition inline-flex items-center gap-2 font-medium shadow-lg">
              Compare Full Pricing <ArrowRight size={20} />
            </button>
          </div> */}
        </div>
      </section>

      {/* Compare Features Section */}
      {/* <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-blue-50 rounded-2xl p-8 md:p-12">
            <h2 className="text-3xl font-medium text-gray-900 mb-4">
              COMPARE FEATURES
            </h2>
            <p className="text-gray-700 text-lg">
              See detailed plans and pricing per product. Compare features,
              add-ons, and integrations across AI Recruiter, 25<sup>th</sup>{" "}
              Direct, and 25<sup>th</sup> Console.
            </p>
          </div>
        </div>
      </section> */}

      {/* FAQ Section */}
      {/* <section
        id="faq"
        className="py-20 bg-gradient-to-b from-blue-50 to-white"
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-medium text-gray-900 mb-12 text-center">
            Frequently Asked Questions
          </h2>

          <div className="space-y-4">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="bg-white rounded-xl shadow-md overflow-hidden"
              >
                <button
                  onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                  className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition"
                >
                  <span className="text-lg text-gray-900">{faq.question}</span>
                  <ChevronDown
                    className={`text-blue-600 transition-transform ${
                      openFaq === idx ? "transform rotate-180" : ""
                    }`}
                    size={24}
                  />
                </button>
                {openFaq === idx && (
                  <div className="px-6 pb-6">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <ContactSalesModal
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
      />
      <FooterComponent />
    </div>
  );
}

export default MainPricing;
